import { HoverPopover } from '@app/components/base/HoverPopover';
import { AuditMatch } from '@app/modules/audit/modules/station-audit/types';
import { toTimestamp } from '@mi-front/core';
import { StreamEl, theme } from '@mi-front/ui';
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import { desaturate } from 'polished';
import { AuditMatchInfo } from './AuditMatchInfo';
import { MatchMarker } from './elements';

interface Props {
  readonly match: AuditMatch;
}

export function AuditMatchMarker({ match }: Props) {
  return (
    <StreamEl key={match.datetime} ts={toTimestamp(match.datetime)} offsetX={-18} zIndex={10}>
      <HoverPopover
        trigger={
          <MatchMarker color={desaturate(0.2, theme.orange)}>
            <AssignmentTurnedInOutlinedIcon fontSize="small" style={{ marginTop: '-6px' }} />
          </MatchMarker>
        }
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        contentSx={{ p: 0, maxWidth: 'none' }}
        paperSx={{ minWidth: 280, maxWidth: 360 }}
        delay={150}
      >
        <AuditMatchInfo match={match} />
      </HoverPopover>
    </StreamEl>
  );
}
